import * as React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import HomePage from "../components/HomePage"
import Seo from "../components/seo"

export const pageQuery = graphql`
  query {
    dashaHome: file(relativePath: { eq: "dashechka.png" }) {
      childImageSharp {
        fluid(maxWidth: 700) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    authorHome: file(relativePath: { eq: "dasha.png" }) {
      childImageSharp {
        fluid(maxWidth: 300) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    authorBack: file(relativePath: { eq: "about.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 700) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`

const Home = ({ data, location }) => (
  <Layout location={location}>
    <Seo
      title="Фитнес-проект Дарьи Стариковой"
      description="«НЕСВЯТАЯ» – фитнес-проект Дарьи Стариковой. Новый офлайн марафон стартует 1 февраля! Успей записаться и скинуть лишнее!"
      location={location}
    />
    <HomePage imgsData={data} location={location} />
  </Layout>
)

export default Home
